var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import IVueDialog from "@/interface/IVueDialog";
import CommonService from "@/api/CommonService";
import LoginService from "@/api/LoginService";
var DialogBindWechat = (function (_super) {
    __extends(DialogBindWechat, _super);
    function DialogBindWechat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.qrcodeImg = '';
        _this.ticket = '';
        _this.loading = false;
        _this.loadingConfirm = false;
        _this.isExpired = false;
        _this.timerDuration = 2000;
        _this.timerResult = null;
        _this.timerQrcode = null;
        return _this;
    }
    DialogBindWechat.prototype.created = function () {
        this.service = LoginService.getInstance();
        this.commonService = CommonService.getInstance();
        this.initQrcode();
    };
    DialogBindWechat.prototype.mounted = function () {
    };
    DialogBindWechat.prototype.beforeDestroy = function () {
        this.clearTimer();
    };
    DialogBindWechat.prototype.clearTimer = function () {
        this.clearResultTimer();
        this.clearQrcodeTimer();
    };
    DialogBindWechat.prototype.getScanResult = function () {
        var _this = this;
        this.clearResultTimer();
        this.service.getWechatScanResult({ ticket: this.ticket }).then(function (res) {
            var _a = res.data, data = _a.data, code = _a.code, msg = _a.msg;
            if (code === 30009) {
                _this.isScan = true;
                _this.clearTimer();
                return _this.$message.warning(msg);
            }
            if (data.token) {
                console.log('------scan login', res);
                _this.isScan = true;
                _this.openId = data.openid;
                _this.unionId = data.unionid;
                _this.clearTimer();
                return _this.handleBindSuccess(data);
            }
            else if (data.openid) {
                _this.clearTimer();
                _this.isScan = true;
                _this.openId = data.openid;
                _this.unionId = data.unionid;
                _this.isUnBindAccount = true;
                _this.$confirm("\n        \u5F53\u524D\u5FAE\u4FE1\u53F7\u6216\u8D26\u53F7\u5DF2\u5B58\u5728\u7ED1\u5B9A\u5173\u7CFB\uFF0C\u662F\u5426\u7EE7\u7EED\u7ED1\u5B9A\uFF1F\n        \uFF08\u7EE7\u7EED\u7ED1\u5B9A\uFF0C\u5C06\u4F1A\u89E3\u7ED1\u4E4B\u524D\u7684\u7ED1\u5B9A\u5173\u7CFB\uFF09\n        ", '提示', {
                    confirmText: '继续绑定'
                })
                    .then(function () {
                    _this.confirm(true);
                }, function () {
                    _this.isUnBindAccount = false;
                    _this.initQrcode();
                });
                return;
            }
            _this.timerResult = setTimeout(function () {
                _this.getScanResult();
            }, _this.timerDuration);
        });
    };
    DialogBindWechat.prototype.clearResultTimer = function () {
        clearInterval(this.timerResult);
    };
    DialogBindWechat.prototype.clearQrcodeTimer = function () {
        clearInterval(this.timerQrcode);
    };
    DialogBindWechat.prototype.getQrcodeStatus = function () {
        var _this = this;
        console.log('getQrcodeStatus');
        if (this.isUnBindAccount)
            return;
        this.clearQrcodeTimer();
        this.service.getWechatQrcodeStatus({ ticket: this.ticket }).then(function (res) {
            var is_expired = res.data.data.is_expired;
            if (is_expired) {
                _this.clearTimer();
                _this.isExpired = true;
                return;
            }
            console.log('------get scan status', res);
            _this.timerQrcode = setTimeout(function () {
                _this.getQrcodeStatus();
            }, _this.timerDuration);
        });
    };
    DialogBindWechat.prototype.initQrcode = function () {
        var _this = this;
        this.clearQrcodeTimer();
        console.log('------initQrcode');
        this.isUnBindAccount = false;
        this.isScan = false;
        this.loading = true;
        this.commonService.getWechatQrcode({ type: 2 }).then(function (res) {
            _this.isExpired = false;
            var _a = res.data.data, url = _a.url, ticket = _a.ticket;
            _this.qrcodeImg = url;
            _this.ticket = ticket;
            _this.getScanResult();
            _this.getQrcodeStatus();
        }).finally(function () {
            _this.loading = false;
        });
    };
    DialogBindWechat.prototype.handleBindSuccess = function (data) {
        console.log('------bind success', data);
        this.$closeDialog();
        this.$message.success('绑定成功');
        this.$emit('success', data);
    };
    DialogBindWechat.prototype.confirm = function (isConfirm) {
        var _this = this;
        if (isConfirm === void 0) { isConfirm = false; }
        var data = {
            phone: this.user.phone,
            sms_code: 'scan',
            openid: this.openId || '',
            unionid: this.unionId || '',
            is_confirm: isConfirm
        };
        console.log('------confirm', isConfirm);
        this.loadingConfirm = true;
        this.commonService.bindAccmount(data).then(function (res) {
            var _a = res.data, data = _a.data, code = _a.code;
            if (data.token) {
                _this.handleBindSuccess(data);
            }
            else if (code === 30009) {
                _this.$message.warning(msg);
            }
            console.log('------res', res);
        }, function (error) {
            _this.$message.error(error.message);
        }).finally(function () {
            _this.loadingConfirm = false;
        });
    };
    DialogBindWechat = __decorate([
        Component
    ], DialogBindWechat);
    return DialogBindWechat;
}(IVueDialog));
export default DialogBindWechat;
